import React from 'react';
import { Link } from 'react-router-dom';

const SupportDictionariesRu = () => (
  <div className="help-page row-fluid">
    <div>
      <header>
        <h1>Помощь</h1>
        <p>
          Если вы не нашли ответа на свой вопрос - обратитесь в службу поддержки Почты России по телефону <b>8-800-100-00-00</b> или напишите на&ensp;
          <a href="mailto:client@russianpost.ru?subject=Отслеживание отправлений через API">client@russianpost.ru</a>
        </p>
      </header>
      <article>
        <h2 id="dictionaries">Справочники</h2>
        <p>
          <Link to="/support/dictionaries/operation_codes">Коды операций над отправлениями и атрибутов операций</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/category_codes">Коды категорий почтовых и непочтовых отправлений</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/mailrank">Коды разрядов почтовых отправлений</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/mailtype">Коды видов почтовых отправлений</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/postmark">Коды отметок почтовых отправлений</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/countries">Коды стран пересылки почтовых отправлений</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/send_ctg">Коды категорий отправителей</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/event_type">Коды операций с наложенным платежом</Link>
        </p>
        <p>
          <Link to="/support/dictionaries/special-termins">Специальные термины</Link>
        </p>
      </article>
      <footer>
        <p>Если вы не нашли ответа на свой вопрос — обратитесь в службу поддержки Почты России</p>
        <h2>
          <b>8-800-100-00-00</b> или&ensp;
          <a href="mailto:client@russianpost.ru?subject=Отслеживание отправлений через API">client@russianpost.ru</a>
        </h2>
      </footer>
    </div>
  </div>
);

export default SupportDictionariesRu;
